import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import _ from 'lodash';
import uuid from 'react-uuid';
// import Decimal from 'decimal.js';
// import NumberFormat from 'react-number-format';
// import { MAX_LIMIT } from 'modules/common/constants';
import { ucwords, numberWithCommas } from 'helper';
import BusinessActivityCreateModal from './BusinessActivityCreateModal';
import BusinessActivityUpdateModal from './BusinessActivityUpdateModal';
import * as c from '../../../constant';
import * as actions from '../../../actions';

function BusinessActivityList({
  businessId,
  getBusinessActivityList,
  businessActivityList,
  removeBusinessActivity,

  createBusinessActivity,
  updateBusinessActivity,

  type,
  activityList,
}) {
  const [viewForm, setViewForm] = useState(false);
  const [viewUpdateForm, setViewUpdateForm] = useState(false);
  const [formData, setFormData] = useState('');
  const [detailFormData, setDetailFormData] = useState({});
  const [formDataQuantityMatrix, setFormDataQuantityMatrix] = useState({});

  useEffect(() => {
    getBusinessActivityList(businessId, () => {
      setViewForm(false);
      setViewUpdateForm(false);
    });
  }, [businessId]);

  const handleAddBusinessActivity = (e) => {
    e.preventDefault();
    setViewForm(true);
    setViewUpdateForm(false);
  };

  const handleUpdateBusinessActivity = (id, data) => (e) => {
    e.preventDefault();
    setViewUpdateForm(true, setFormData(data));
    setViewForm(false);
  };

  const closeModal = () => {
    setViewForm(false);
  };

  const closeUpdateModal = () => {
    setViewUpdateForm(false);
  };

  const handleRemoveBusinessActivity = (id, data) => (e) => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure you want to remove this business activity?',
      () => {
        removeBusinessActivity(id, data.id, () => {
          getBusinessActivityList(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleOnCreate = (data) => (e) => {
    e.preventDefault();
    const businessNecessary = {
      ...detailFormData,
      quantity_matrix: formDataQuantityMatrix,
    };

    ConfirmAlert(
      'Are you sure you want to add this business activity?',
      () => {
        const args = {
          business_nature_id: _.get(data, 'business_nature_id') || 0,
          business_line_id: _.get(data, 'business_line_id') || 0,
          capital_amount: _.get(data, 'capital_amount') || 0,
          gross_amount: _.get(data, 'gross_amount') || 0,
          industrial_code: _.get(data, 'industrial_code') || 0,
          details: businessNecessary || {},
        };
        createBusinessActivity(businessId, args, () => {
          getBusinessActivityList(businessId);
          setViewForm(false);
          setDetailFormData({});
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleOnUpdate = (data) => (e) => {
    e.preventDefault();
    const businessActivityId = _.get(formData, 'id');
    const businessNecessary = {
      ...detailFormData,
      quantity_matrix: formDataQuantityMatrix,
    };

    ConfirmAlert(
      'Are you sure you want to add this business activity?',
      () => {
        const args = {
          business_nature_id: _.get(data, 'business_nature_id'),
          business_line_id: _.get(data, 'business_line_id'),
          capital_amount: _.get(data, 'capital_amount').replace(/,/g, ''),
          gross_amount: _.get(data, 'gross_amount').replace(/,/g, ''),
          industrial_code: _.get(data, 'industrial_code') || 0,
          details: businessNecessary || {},
        };

        updateBusinessActivity(businessId, businessActivityId, args, () => {
          setViewUpdateForm(false);
          getBusinessActivityList(businessId);
          setDetailFormData({});
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const newBusinessActivityList = (businessActivityList || []).filter((item) =>
    _.get(item, 'attributes.is_new_addition', 1)
  );

  return (
    <div>
      {viewForm === true && (
        <BusinessActivityCreateModal
          businessId={businessId}
          closeModal={closeModal}
          handleOnCreate={handleOnCreate}
          detailFormData={detailFormData}
          setDetailFormData={setDetailFormData}
          formDataQuantityMatrix={formDataQuantityMatrix}
          setFormDataQuantityMatrix={setFormDataQuantityMatrix}
        />
      )}
      {viewUpdateForm === true && (
        <BusinessActivityUpdateModal
          businessId={businessId}
          closeUpdateModal={closeUpdateModal}
          businessActivityInfo={formData}
          handleOnUpdate={handleOnUpdate}
          detailFormData={detailFormData}
          setDetailFormData={setDetailFormData}
          formDataQuantityMatrix={formDataQuantityMatrix}
          setFormDataQuantityMatrix={setFormDataQuantityMatrix}
        />
      )}
      {type !== 'VIEW' && (
        <div className="text-right pb-3">
          <button
            type="button"
            className="btn btn-primary cms-bg-color-primary cms-outline-primary"
            onClick={handleAddBusinessActivity}
          >
            Add Business Activity
          </button>
        </div>
      )}
      <div className='border rounded-lg mb-3'>
        <table className="table table-sm table-borderless table-striped mb-0">
          <thead>
            <tr className="border-bottom text-primary text-center">
              <th
                width="200"
                className="border-right"
              >
                Line of Business
              </th>
              <th width="200" className="border-right">
                Philippine Standard Industrial Code
              </th>
              <th
                width="300"
                className="border-right"
              >
                Details
              </th>
              <th
                width="250"
                className="border-right"
              >
                Total Capitalization (Ph)
              </th>
              {type !== 'VIEW' && (
                <th
                  width="200"
                />
              )}
            </tr>
          </thead>
          <tbody>
            {type !== 'VIEW' &&
              newBusinessActivityList.map((item) => {
                const details = _.get(item, 'attributes.details');
                const { quantity_matrix, quantity_matrix_details, ...detail } = details;
                // const multiplierQuantityMatrix = Object.values(quantity_matrix ?? {})
                //   .flatMap(x => _.isArray(x) ? x : [])
                //   .reduce((acc, { multiplier, value }) => {
                //     if (multiplier && !Number.isNaN(value)) {
                //       acc[multiplier] = +value;
                //     }
                //     return acc;
                //   }, {});

                return (
                  <React.Fragment key={item.id}>
                    <tr>
                      <td className='border-right'>
                        {_.get(item, 'attributes.name') || '-'}
                      </td>
                      <td className='border-right'>
                        {_.get(item, 'attributes.industrial_code') || '-'}
                      </td>
                      <td className='border-right'>
                        <div>
                          {detail
                          ? Object.entries(detail).map((x) => {
                              return (
                                <div key={`bpls_business_detail${x[0]}`}>
                                  {ucwords(
                                      x[0].replace(/_/g, ' ') || null
                                    )} : {x[1] || null}
                                </div>
                                // <input
                                //   key={`bpls_business_detail${x[0]}`}
                                //   type="text"
                                //   readOnly
                                //   className="custom-input my-2 text-uppercase"
                                //   value={`${ucwords(
                                //     x[0].replace(/_/g, ' ') || null
                                //   )}: ${x[1] || null}`}
                                // />
                              );
                            }) || '-'
                          : ''}
                        </div>
                        <div>
                          {!_.isEmpty(quantity_matrix) ? (
                            Object.entries(quantity_matrix).map(([label, data]) => {

                              return (
                                <React.Fragment>
                                  <div key={uuid()} className='text-capitalize'>
                                    {label || ''}{' '}:
                                  </div>
                                  <div className='p-1'>
                                    <div className='w-100 border rounded-lg mb-2'>
                                      <table className="table table-borderless table-sm table-striped table-hover mb-0">
                                        <thead>
                                          <tr className='form-group'>
                                            <td className='col-4 form-label text-center border-right'>Unit</td>
                                            <td className='col-4 form-label text-center border-right'>Capacity</td>
                                            <td className='col-4 form-label text-center'>Number of Units</td>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {data.map((x) => {
                                            return (
                                              // eslint-disable-next-line react/no-array-index-key
                                              <tr key={uuid()} className="border-top form-group">
                                                <td className="col-4 text-left form-label border-right">
                                                  {_.get(x, 'unit')} 
                                                </td>
                                                <td className="col-4 text-left form-label border-right">
                                                  {_.get(x, 'capacity')}
                                                </td>
                                                <td className="col-4 text-left form-label">
                                                  {numberWithCommas(x.value) || 0}
                                                </td>
                                              </tr>
                                            );
                                          })
                                        }
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </React.Fragment>
                              )
                            })
                          ) : (
                            ''
                          )}
                        </div>
                      </td>

                      <td className='border-right'>
                        {
                          _.get(
                            item,
                            'attributes.capital_amount_human'
                          ) || '-'
                        }
                        {/* <NumberFormat
                          name="capital_amount"
                          id="capital_amount"
                          placeholder="0.00"
                          className="form-control my-2"
                          displayType="input"
                          decimalScale={2}
                          isNumericString
                          allowNegative
                          thousandSeparator
                          allowLeadingZeros
                          readOnly
                          prefix="₱ "
                          value={_.get(item, 'attributes.capital_amount') || 0}
                          isAllowed={(values) => {
                            const { value } = values;
                            if (!value) return true;
                            const val = new Decimal(value);
                            const max = new Decimal(MAX_LIMIT);
                            return value === undefined || val.lte(max);
                          }}
                        /> */}
                        {/* <input
                          type="text"
                          readOnly
                          className="custom-input my-2"
                          value={
                            _.get(item, 'attributes.capital_amount_human') || 0
                          }
                        /> */}
                      </td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center align-items center my-2">
                          <button
                            onClick={handleUpdateBusinessActivity(
                              businessId,
                              item
                            )}
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
                          >
                            Update
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary"
                            onClick={handleRemoveBusinessActivity(
                              businessId,
                              item
                            )}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            {type === 'VIEW' &&
              activityList.map((item, i) => {
                return (
                  <tr key={`Item ${i + 1}`}>
                    <td>
                      <input
                        type="text"
                        readOnly
                        className="custom-input my-2"
                        value={_.get(item, 'attributes.name') || '-'}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        readOnly
                        className="custom-input my-2"
                        value={_.get(item, 'attributes.industrial_code') || '-'}
                      />
                    </td>
                    <td>
                      {_.get(item, 'attributes.details')
                        ? Object.entries(_.get(item, 'attributes.details')).map(
                            (x) => {
                              return (
                                <input
                                  key={`bpls_business_detail${x[0]}`}
                                  type="text"
                                  readOnly
                                  className="custom-input my-2 text-uppercase"
                                  value={`${ucwords(
                                    x[0].replace(/_/g, ' ') || null
                                  )}: ${x[1] || null}`}
                                />
                              );
                            }
                          ) || '-'
                        : ''}
                    </td>
                    <td>
                      <input
                        type="text"
                        readOnly
                        className="custom-input my-2"
                        value={_.get(item, 'attributes.capital_amount') || '-'}
                      />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

BusinessActivityList.defaultProps = {
  type: '',
  activityList: [],
};

BusinessActivityList.propTypes = {
  businessId: PropTypes.string.isRequired,
  getBusinessActivityList: PropTypes.instanceOf(Function).isRequired,
  businessActivityList: PropTypes.instanceOf(Array).isRequired,
  removeBusinessActivity: PropTypes.instanceOf(Function).isRequired,
  createBusinessActivity: PropTypes.instanceOf(Function).isRequired,
  updateBusinessActivity: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
  activityList: PropTypes.instanceOf(Array),
};

const mapStateToProps = ({ api }) => ({
  businessActivityList:
    _.get(api, `${c.GET_BUSINESS_ACTIVITY_LIST}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BusinessActivityList);
